export default __webpack_public_path__ + "static/media/wfh.4ef463ec.svg";